module.exports = __webpack_public_path__ + "img/app_logo_main_002.73d58054.png";